var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.694,
    height: 8.312,
    viewBox: "0 0 14.694 8.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chevron_right_FILL0_wght400_GRAD0_opsz48",
    d: "M17.548,26.894a1.189,1.189,0,0,1-.273-.707.87.87,0,0,1,.273-.675l5.658-5.658-5.69-5.69a.885.885,0,0,1-.241-.691.989.989,0,0,1,.273-.691.908.908,0,0,1,.691-.305.971.971,0,0,1,.659.305l6.4,6.4a.98.98,0,0,1,.225.321,1,1,0,0,1,0,.707.98.98,0,0,1-.225.321L18.93,26.894a.87.87,0,0,1-.675.273A1.189,1.189,0,0,1,17.548,26.894Z",
    transform: "translate(27.168 -17.274) rotate(90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcons);
export default __webpack_public_path__ + "static/media/chevron_right_icons.90976f4a08e8c4d712c94352cf1b5f69.svg";
export { ForwardRef as ReactComponent };